<!-- begin:: Brand -->
<div class="kt-aside__brand kt-grid__item" [ngClass]="htmlClassService.getClasses('brand', true)" id="kt_aside_brand">
	<div class="kt-aside__brand-logo">
		<a href="javascript:;" routerLink="/">
			<img alt="logo" [attr.src]="headerLogo"/>
		</a>
	</div>
	<div class="kt-aside__brand-tools">
		<button ktToggle [options]="toggleOptions" class="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left" id="kt_aside_toggler" type="button">
			<!-- Spans required: _brand.scss toggles visibility with > span:nth-child(1|2); plain <img> siblings broke that -->
			<span class="kt-svg-icon">
				<img alt="" src="assets/media/icons/svg/Navigation/Angle-double-left.svg" width="16" height="16" />
			</span>
			<span class="kt-svg-icon">
				<img alt="" src="assets/media/icons/svg/Navigation/Angle-double-right.svg" width="16" height="16" />
			</span>
		</button>
	</div>
</div>
<!-- end:: Brand -->
